<template>
  <PostgresqlConfiguration v-if="type === DATA_ADAPTERS.POSTGRESQL.key" :forUser="forUser" :default-config="config" ref="configuration" @update:defaultConfig="emitPayload" />
  <GoogleAnalyticsConfiguration v-else-if="type === DATA_ADAPTERS.GOOGLE_ANALYTICS.key" :default-config="config" ref="configuration" @update:defaultConfig="emitPayload" />
  <XeroConfiguration v-else-if="type === DATA_ADAPTERS.XERO.key" :default-config="config" ref="configuration" @update:defaultConfig="emitPayload" />
  <MysqlConfiguration v-else-if="type === DATA_ADAPTERS.MYSQL.key" :forUser="forUser" :default-config="config" ref="configuration" @update:defaultConfig="emitPayload" />
  <MssqlConfiguration v-else-if="type === DATA_ADAPTERS.MSSQL.key" :forUser="forUser" :default-config="config" ref="configuration" @update:defaultConfig="emitPayload" />
  <LushaConfiguration v-else-if="type === DATA_ADAPTERS.LUSHA.key" :forUser="forUser" :default-config="config" ref="configuration" @update:defaultConfig="emitPayload" />
  <CloudflareD1Configuration v-else-if="type === DATA_ADAPTERS.CLOUDFLARE_D1.key" :forUser="forUser" :default-config="config" ref="configuration" @update:defaultConfig="emitPayload" />
</template>

<script>
import { DATA_ADAPTERS } from '../../constants';
import XeroConfiguration from './XERO.vue';
import GoogleAnalyticsConfiguration from './GOOGLE_ANALYTICS.vue';
import PostgresqlConfiguration from './POSTGRESQL.vue';
import MysqlConfiguration from './MYSQL.vue';
import MssqlConfiguration from './MSSQL.vue';
import CloudflareD1Configuration from './CLOUDFLARE_D1.vue';
import LushaConfiguration from './LUSHA.vue';

export default {
  name: 'DataAdapterConfiguration',
  components: { PostgresqlConfiguration, GoogleAnalyticsConfiguration, XeroConfiguration, MysqlConfiguration, MssqlConfiguration, LushaConfiguration, CloudflareD1Configuration },
  props: {
    type: {
      type: String,
      default: null,
    },
    config: {
      type: Object,
      default: null,
    },
    forUser: {
      type: Boolean,
    },
  },
  data() {
    return {
      DATA_ADAPTERS,
    };
  },
  methods: {
    validate() {
      return this.$refs.configuration.validate();
    },
    emitPayload(e) {
      this.$emit('update:config', e);
    },
  },
};
</script>
